import API from "../../../../app/api";

export const getSimilarStyle = async (categoryslug) => {
  try {
    if (!categoryslug) {
      throw new Error("Similar style category slug is required");
    }
    const res = await API.get(
      `/products/details/recommended/similar-styles/${categoryslug}`
    );
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch Similar Style");
    }
    //  console.log(res.data.data)
    return res.data.data || [];
  } catch (error) {
    console.error("getSimilarStyle error:", error);
    throw error;
  }
};